// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-7dbcb630] {\n  margin: 1.2em 0;\n}\n.control-min-width[data-v-7dbcb630] {\n  min-width: 18em;\n}", ""]);
// Exports
module.exports = exports;
